<template>
    <section>
        <div v-if="!single" class="is-relative">
            <h3 class="stepper__content__header">{{ $t('MEDICAL_DATA') }}</h3>
        </div>
        <steps v-if="!single" :activeStep="1" :steps="5" class="text-xs-center mb-4"></steps>
        <div class="content__wrapper">
            <div class="breast-size__box" v-if="showBreastSizeInfoBox">
                <h4>{{ $t('YOUR_BRASTER_BREAST_SIZE') }}</h4>
                <div class="number-circle">{{ s4q1Val }}</div>
                <p>{{ $t('DURING_BRASTER_EXAMINATION', { number: breastApplicationNumber }) }}</p>
                <button
                    @click="
                        showBreastSizeInfoBox = false;
                        s4q1Val = '';
                    "
                >
                    {{ $t('CHANGE_SIZE') }}
                </button>
            </div>
            <div v-else>
                <div class="d-flex align-center">
                    <h4 class="stepper__content__title with-description">
                        {{ $t('GIVE_YOUR_BREAST_SIZE') }}
                    </h4>
                    <div class="description box-shadow box-shadow--arrow-left">
                        {{ $t('GIVE_YOUR_BREAST_SIZE_INFO') }}
                    </div>
                </div>
                <br />
                {{ $t('GIVE_YOUR_BREAST_SIZE_INFO_1') }}
                <div class="flex-row row mt-5 mb-3">
                    <div class="col-xs-12 mb-3">
                        <label class="fake-label" style="left:15px">
                            <input
                                class="custom-input"
                                type="radio"
                                value="1"
                                name="right-breast"
                                @click="onSelectSize(1)"
                                v-model="selectedImage"
                            />
                            <span class="input-container no-border"></span>
                            <span class="checkmark"></span>
                        </label>
                        <img
                            class="breast-img"
                            @click="onSelectSize(1)"
                            src="/src/assets/images/breast_sizes/r1_1p.jpg"
                        />
                        <img
                            class="breast-img"
                            @click="onSelectSize(1)"
                            src="/src/assets/images/breast_sizes/r1_1b.jpg"
                        />
                    </div>
                    <div class="col-xs-12 mb-3">
                        <label class="fake-label" style="left:15px">
                            <input
                                class="custom-input"
                                type="radio"
                                value="2"
                                name="right-breast"
                                @click="onSelectSize(2)"
                                v-model="selectedImage"
                            />
                            <span class="input-container no-border"></span>
                            <span class="checkmark"></span>
                        </label>
                        <img
                            class="breast-img"
                            @click="onSelectSize(2)"
                            src="/src/assets/images/breast_sizes/r3_1p.jpg"
                        />
                        <img
                            class="breast-img"
                            @click="onSelectSize(2)"
                            src="/src/assets/images/breast_sizes/r3_1b.jpg"
                        />
                    </div>
                    <div class="col-xs-12 mb-3">
                        <label class="fake-label" style="left:15px">
                            <input
                                class="custom-input"
                                type="radio"
                                value="3"
                                name="right-breast"
                                @click="onSelectSize(3)"
                                v-model="selectedImage"
                            />
                            <span class="input-container no-border"></span>
                            <span class="checkmark"></span>
                        </label>
                        <img
                            class="breast-img"
                            @click="onSelectSize(3)"
                            src="/src/assets/images/breast_sizes/r2_1p.jpg"
                        />
                        <img
                            class="breast-img"
                            @click="onSelectSize(3)"
                            src="/src/assets/images/breast_sizes/r2_1b.jpg"
                        />
                    </div>
                    <div class="col-xs-12 mb-3">
                        <label class="fake-label" style="left:15px">
                            <input
                                class="custom-input"
                                type="radio"
                                value="4"
                                name="right-breast"
                                @click="onSelectSize(4)"
                                v-model="selectedImage"
                            />
                            <span class="input-container no-border"></span>
                            <span class="checkmark"></span>
                        </label>
                        <img
                            class="breast-img"
                            @click="onSelectSize(4)"
                            src="/src/assets/images/breast_sizes/r2_2p.jpg"
                        />
                        <img
                            class="breast-img"
                            @click="onSelectSize(4)"
                            src="/src/assets/images/breast_sizes/r2_2b.jpg"
                        />
                    </div>
                    <div class="col-xs-12 mb-3">
                        <label class="fake-label" style="left:15px">
                            <input
                                class="custom-input"
                                type="radio"
                                value="5"
                                name="right-breast"
                                @click="onSelectSize(5)"
                                v-model="selectedImage"
                            />
                            <span class="input-container no-border"></span>
                            <span class="checkmark"></span>
                        </label>
                        <img
                            class="breast-img"
                            @click="onSelectSize(5)"
                            src="/src/assets/images/breast_sizes/r3_2p.jpg"
                        />
                        <img
                            class="breast-img"
                            @click="onSelectSize(5)"
                            src="/src/assets/images/breast_sizes/r3_2b.jpg"
                        />
                    </div>
                    <div class="col-xs-12 mb-3">
                        <label class="fake-label" style="left:15px">
                            <input
                                class="custom-input"
                                type="radio"
                                value="6"
                                name="right-breast"
                                @click="onSelectSize(6)"
                                v-model="selectedImage"
                            />
                            <span class="input-container no-border"></span>
                            <span class="checkmark"></span>
                        </label>
                        <img
                            class="breast-img"
                            @click="onSelectSize(6)"
                            src="/src/assets/images/breast_sizes/r4_2p.jpg"
                        />
                        <img
                            class="breast-img"
                            @click="onSelectSize(6)"
                            src="/src/assets/images/breast_sizes/r4_2b.jpg"
                        />
                    </div>
                    <div class="col-xs-12 mb-3">
                        <label class="fake-label" style="left:15px">
                            <input
                                class="custom-input"
                                type="radio"
                                value="7"
                                name="right-breast"
                                @click="onSelectSize(7)"
                                v-model="selectedImage"
                            />
                            <span class="input-container no-border"></span>
                            <span class="checkmark"></span>
                        </label>
                        <img
                            class="breast-img"
                            @click="onSelectSize(7)"
                            src="/src/assets/images/breast_sizes/r4_1p.jpg"
                        />
                        <img
                            class="breast-img"
                            @click="onSelectSize(7)"
                            src="/src/assets/images/breast_sizes/r4_1b.jpg"
                        />
                    </div>
                    <div class="col-xs-12 mb-3">
                        <label class="fake-label" style="left:15px">
                            <input
                                class="custom-input"
                                type="radio"
                                value="8"
                                name="right-breast"
                                @click="onSelectSize(8)"
                                v-model="selectedImage"
                            />
                            <span class="input-container no-border"></span>
                            <span class="checkmark"></span>
                        </label>
                        <img
                            class="breast-img"
                            @click="onSelectSize(8)"
                            src="/src/assets/images/breast_sizes/r5_1p.jpg"
                        />
                        <img
                            class="breast-img"
                            @click="onSelectSize(8)"
                            src="/src/assets/images/breast_sizes/r5_1b.jpg"
                        />
                    </div>
                    <div class="col-xs-12 mb-3">
                        <label class="fake-label" style="left:15px">
                            <input
                                class="custom-input"
                                type="radio"
                                value="9"
                                name="right-breast"
                                @click="onSelectSize(9)"
                                v-model="selectedImage"
                            />
                            <span class="input-container no-border"></span>
                            <span class="checkmark"></span>
                        </label>
                        <img
                            class="breast-img"
                            @click="onSelectSize(9)"
                            src="/src/assets/images/breast_sizes/r5_2p.jpg"
                        />
                        <img
                            class="breast-img"
                            @click="onSelectSize(9)"
                            src="/src/assets/images/breast_sizes/r5_2b.jpg"
                        />
                    </div>
                </div>
            </div>
            <div class="text-center">
                <div v-if="single">
                    <button @click="$emit('cancel')" class="w160 mr-3 app-btn app-btn--small app-btn-default mt-3">
                        {{ $t('CANCEL') }}
                    </button>
                    <button v-if="!s4q1Val" class="w160 mr-3 app-btn app-btn--small mt-3" style="opacity: 0.5;">
                        {{ $t('SAVE') }}
                    </button>
                    <button
                        v-if="s4q1Val && !showBreastSizeInfoBox"
                        @click="
                            showBreastSizeInfoBox = true;
                            $scrollTo('#DaneMedyczne', 1000, { offset: -30 });
                        "
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('SAVE') }}
                    </button>
                    <button
                        v-if="s4q1Val && showBreastSizeInfoBox"
                        @click="save"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('SAVE') }}
                    </button>
                </div>
                <div v-else>
                    <button v-if="!s4q1Val" class="w160 mr-3 app-btn app-btn--small mt-3" style="opacity: 0.5;">
                        {{ $t('SAVE') }}
                    </button>
                    <button
                        v-if="s4q1Val && !showBreastSizeInfoBox"
                        @click="showBreastSizeInfoBox = true"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('SAVE') }}
                    </button>
                    <button
                        v-if="s4q1Val && showBreastSizeInfoBox"
                        @click="goNext"
                        class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                    >
                        {{ $t('NEXT') }}
                    </button>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Steps from './helpers/steps.vue';
import { mapActions, mapState } from 'vuex';
import { mapUserSurveyData } from '../../../main';

export default {
    created() {
        if (
            this.$store.getters.survey.section4.q1 == 1 ||
            this.$store.getters.survey.section4.q1 == 2 ||
            this.$store.getters.survey.section4.q1 == 3 ||
            this.$store.getters.survey.section4.q1 == 4 ||
            this.$store.getters.survey.section4.q1 == 5
        ) {
            this.s4q1Val = this.$store.getters.survey.section4.q1;
            this.showBreastSizeInfoBox = true;
        }
    },
    name: 'survey-step4-q1',
    props: {
        single: Boolean,
    },
    data() {
        return {
            s4q1Val: this.q1,
            showBreastSizeInfoBox: false,
            selectedImage: '',
        };
    },
    computed: {
        ...mapState(['user']),
        breastApplicationNumber() {
            switch (parseInt(this.s4q1Val)) {
                case 1:
                    return 3;
                case 2:
                    return 3;
                case 3:
                    return 3;
                case 4:
                    return 5;
                case 5:
                    return 5;
                default:
                    return 0;
            }
        },
    },
    methods: {
        ...mapActions(['updateUserSurvey']),
        onSelectSize(val) {
            this.selectedImage = val;
            this.s4q1Val = [1, 2, 2, 3, 3, 4, 4, 5, 5][val - 1];

            this.$store.commit('STATE_SURVEY', {
                section4: {
                    ...this.$store.getters.survey.section4,
                    active_section: 2,
                    q1: this.s4q1Val,
                },
            });
        },
        goNext() {
            this.$store.commit('STATE_SURVEY', {
                section4: {
                    ...this.$store.getters.survey.section4,
                    active_section: 2,
                    q1: this.s4q1Val,
                },
            });
        },
        save() {
            this.updateUserSurvey({ ...this.user.patient.survey, ...mapUserSurveyData() }).then(() => {
                this.$store.commit('STATE_SURVEY', {
                    section4: {
                        ...this.$store.getters.survey.section4,
                        q1: this.s4q1Val,
                    },
                });
                this.$emit('save');
            });
        },
    },
    components: {
        Steps,
    },
};
</script>

<style lang="scss" scoped>
label {
    display: inline-flex;
    min-width: 1px;
    float: left;
}

.breast-img {
    cursor: pointer;
    float: left;
    width: 50%;
    max-width: 100%;
    padding-bottom: 5px;
}

.div-breast {
    padding-left: 42px;
}

.breast-size__box {
    background-color: #f1eeea;
    border: 1px solid #ede8e4;
    padding: 25px;
    text-align: center;
    width: 70%;
    margin: 0 auto 25px;

    h4 {
        font-size: 24px;
    }

    p {
        font-size: 14px;
    }

    button {
        color: #cf004a;
        font-size: 14px;
        font-weight: 700;
        display: inline-flex;
    }
}

.number-circle {
    align-items: center;
    background-color: white;
    border: 2px solid #a6cc33;
    border-radius: 50%;
    color: #a6cc33;
    display: inline-flex;
    justify-content: center;
    font-size: 26px;
    margin: 20px auto;
    width: 50px;
    height: 50px;
}

@media (max-width: 768px) {
    .breast-img {
        max-width: 100%;
    }

    .breast-size__box {
        width: 100%;
    }
}

.fake-label {
    position: absolute;
}
</style>



// WEBPACK FOOTER //
// survey-step4-q1.vue?48080259